import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { cardTypes } from 'apps/notificationCenter/index';

import Button from 'components/Button';
import Spinner from 'components/Spinner';

import Header from 'apps/components/header/header';

import styled from 'styled-components';
import { MainWrapper, Center } from 'legacyComponents/styled/lib';
import { Section } from 'legacyComponents/layout/section';
import { FullPageWrapper } from 'apps/notificationCenter/styles';

@withNamespaces()
@inject('notificationCenter', 'headerStore')
@observer
export class NotificationsPage extends React.Component {
  UNSAFE_componentWillMount = () => {
    const { notificationCenter, headerStore } = this.props;
    notificationCenter.NewNotificationsQuery();
    headerStore.HideNotifDropdown();
  };

  render() {
    const { notificationCenter } = this.props;
    if (!notificationCenter.notifications) {
      return (
        <>
          <Header />
          <Spinner />
        </>
      );
    }
    const { notifications, notificationsConn } = notificationCenter;

    return (
      <>
        <Header />
        <MainWrapperStyled>
          <Section wrapperStyle={{ marginTop: -8 }}>
            <FullPageWrapper>
              {[...new Set(notifications)].map((notif, index) => {
                const Card = cardTypes[notif.type];
                const key = notif.id || `${notif.type}_${index}`;
                return <Card key={key} id={key} notification={notif} />;
              })}
              <Center>
                {notificationCenter.loading &&
                notificationCenter.notificationsConn.loadedMore ? (
                  <ButtonStyled
                    text={<Trans>Showing more...</Trans>}
                    loading
                    size='small'
                    outline
                    onClick={() => notificationCenter.LoadMore()}
                  />
                ) : notificationCenter.loading ? (
                  <Spinner />
                ) : (
                  notificationsConn?.hasNextPage && (
                    <Button
                      style={{ marginTop: 32 }}
                      text={<Trans>Show more</Trans>}
                      onClick={() => notificationCenter.LoadMore()}
                      outline
                    />
                  )
                )}
              </Center>
            </FullPageWrapper>
          </Section>
        </MainWrapperStyled>
      </>
    );
  }
}

// FIXME: Move these styles to its styled file pending from notifications page
const ButtonStyled = styled(Button)`
  margin: ${props => `${props.theme.spacing.default} 0`};
`;

const MainWrapperStyled = styled(MainWrapper)`
  margin: ${props => `0 auto ${props.theme.spacing.large}`};
`;

NotificationsPage.propTypes = {
  notificationCenter: PropTypes.object,
  headerStore: PropTypes.object,
  t: PropTypes.func,
};
